import { TextAsset } from '../types/';
import { CallToActionEnum } from 'api';
import { convertSnakeCaseToSentenceCase } from 'utils/strings';
import {
  REACH_ALLOW,
  LINK_CLICKS_ALLOW,
  VIDEO_VIEWS_ALLOW,
  CONVERSIONS_ALLOW,
  APP_INSTALLS_ALLOW,
  POST_ENGAGEMENT_ALLOW,
  LEAD_GENERATION_ALLOW,
  CampaignObjectivesEnum,
  PAGE_LIKES_ALLOW
} from '../constants';

const campaignObjectiveFilter = (campaignObjective: CampaignObjectivesEnum, key: CallToActionEnum): boolean => {
  switch (campaignObjective) {
    case CampaignObjectivesEnum.LEAD_GENERATION:
      return LEAD_GENERATION_ALLOW.includes(key);

    case CampaignObjectivesEnum.APP_INSTALLS:
      return APP_INSTALLS_ALLOW.includes(key);

    case CampaignObjectivesEnum.REACH:
      return REACH_ALLOW.includes(key);

    case CampaignObjectivesEnum.LINK_CLICKS:
      return LINK_CLICKS_ALLOW.includes(key);

    case CampaignObjectivesEnum.POST_ENGAGEMENT:
      return POST_ENGAGEMENT_ALLOW.includes(key);

    case CampaignObjectivesEnum.PAGE_LIKES:
      return PAGE_LIKES_ALLOW.includes(key);

    case CampaignObjectivesEnum.VIDEO_VIEWS:
      return VIDEO_VIEWS_ALLOW.includes(key);

    case CampaignObjectivesEnum.CONVERSIONS:
      return CONVERSIONS_ALLOW.includes(key);

    case CampaignObjectivesEnum.ALL_CAMPAIGN_OBJECTIVES:
    default:
      return true;
  }
};

export const getCallToActionTextAssets = (campaignObjective: CampaignObjectivesEnum): TextAsset[] => {
  return Object.keys(CallToActionEnum)
    .filter((key) => campaignObjectiveFilter(campaignObjective, key as CallToActionEnum))
    .map((key) => ({ id: key, text: convertSnakeCaseToSentenceCase(key) }));
};
